var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndividualAnnouncements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.77778 8.00043H16V18.6671H2.81778L1.77778 19.7071V8.00043ZM1.77778 6.22266C0.8 6.22266 0.00888888 7.02266 0.00888888 8.00043L0 24.0004L3.55556 20.4449H16C16.9778 20.4449 17.7778 19.6449 17.7778 18.6671V8.00043C17.7778 7.02266 16.9778 6.22266 16 6.22266H1.77778ZM3.55556 15.1115H14.2222V16.8893H3.55556V15.1115ZM3.55556 12.4449H14.2222V14.2227H3.55556V12.4449ZM3.55556 9.77821H14.2222V11.556H3.55556V9.77821Z",
    fill: "#007AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33334 1.77778H19.5556V12.4444H16L16.0002 8L5.33334 7.11111V1.77778ZM5.33334 0C4.35556 0 3.56445 0.8 3.56445 1.77778V7.11111L16.0002 8L16 14.2222H19.5556C20.5333 14.2222 21.3333 13.4222 21.3333 12.4444V1.77778C21.3333 0.8 20.5333 0 19.5556 0H5.33334ZM16.0002 8.88889H17.778V10.6667H16.0001L16.0002 8.88889ZM7.11112 6.22222H14.2222L15.1111 8H7.11112V6.22222ZM7.11112 3.55556H17.7778V5.33333H7.11112V3.55556Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualAnnouncements);
export default __webpack_public_path__ + "static/media/individual_announcements.fcaa991e.svg";
export { ForwardRef as ReactComponent };